<div class="homework-detail">
  <div class="homework-container">
    <div class="modal-course-detail" *ngIf="homework">
      <div class="course-title">{{'learning-online.courseDetail' | transloco }}</div>
      <div class="course-detail">
        <img class="course-img"
          src="https://external.fhan14-2.fna.fbcdn.net/emg1/v/t13/13063443824965193793?url=http%3A%2F%2Fapi.edunetvn.ml%2Fapi%2Fpublic%2Flogo.png&fb_obo=1&utld=edunetvn.ml&stp=c0.5000x0.5000f_dst-jpg_flffffff_p500x261_q75&ccb=13-1&oh=00_AT_PXiCt0afbAgU9P2nouN8oZsbITXu7otcZ2x1JHwZG3w&oe=62E41A56&_nc_sid=c504da" />
        <div class="description">
          <div class="description-item">
            <div class="description-key">{{'homework.level' | transloco }}:</div>
            <div class="description-value">{{homework.level}}</div>
          </div>
          <div class="description-item">
            <div class="description-key">{{'homework.subject' | transloco }}:</div>
            <div class="description-value">{{homework.subject}}</div>
          </div>
          <div class="description-item">
            <div class="description-key">{{'homework.class' | transloco }}:</div>
            <div class="description-value">{{homework.class}}</div>
          </div>
          <div class="description-item">
            <div class="description-key">{{'homework.content' | transloco }}:</div>
            <div class="description-value" [innerHTML]="homework.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
